/**
 * Widget class constraints per Figma canvas drag behavior spec.
 * - Class 1 & 2: Resize handles = Sides only (n, s, e, w)
 * - Class 3: Resize handles = None (drag handle = Topbar for all)
 */
export const WIDGET_CLASS_CONSTRAINTS = Object.freeze({
  CLASS_1_COMPACT: {
    minH: 4,
    maxH: 5,
    minW: 4,
    maxW: 8,
    scroll: false,
  },
  CLASS_2_STANDARD: {
    minH: 7,
    maxH: 9,
    minW: 4,
    maxW: 8,
    scroll: 'optional',
  },
  CLASS_3_HEAVY: {
    minH: 7,
    maxH: Infinity,
    minW: 4,
    maxW: 12,
    scroll: true,
  },
});

export const GRID_MARGIN = [16, 16];

export const DRAG_HANDLE_OFFSET_PX = 12;

/** Margen extra para IntersectionObserver: inicia fetch antes de que el widget entre en viewport */
export const WIDGET_LAZY_LOAD_ROOT_MARGIN = '100px';

/** Breakpoints para Responsive (min-width en px)*/
export const BREAKPOINTS = Object.freeze({
  lg: 1200,
  md: 996,
  sm: 768,
  xs: 480,
  xxs: 0,
});

/** Columnas por breakpoint. Desktop/tablet (lg/md) mantiene Figma 12 cols; móvil apilado. */
export const BREAKPOINT_COLS = Object.freeze({
  lg: 12,
  md: 12,
  sm: 12,
  xs: 4,
  xxs: 2,
});
